import { DateTime } from 'luxon'

/**
 * Format time for thread list display
 * Rules:
 * - Just time when it is current day (i.e. "11:32 AM")
 * - Day abbreviation and time within the last week (i.e. "Tues 11:58 AM")
 * - Date abbreviation when beyond the last week (i.e. "Dec 14")
 * - Full date when beyond the last year (i.e. "12/24/24")
 */
export function formatThreadListTime(date: Date | string): string {
  const jsDate = date instanceof Date ? date : new Date(date)
  const dt = DateTime.fromJSDate(jsDate)
  const now = DateTime.now()

  // Check if same day
  if (dt.hasSame(now, 'day')) {
    return dt.toFormat('h:mm a') // "11:32 AM"
  }

  // Check if within last 7 days
  const daysDiff = now.diff(dt, 'days').days
  if (daysDiff < 7) {
    return dt.toFormat('EEE h:mm a') // "Tues 11:58 AM"
  }

  // Check if same year
  if (dt.hasSame(now, 'year')) {
    return dt.toFormat('MMM d') // "Dec 14"
  }

  // Different year
  return dt.toFormat('M/d/yy') // "12/24/24"
}

/**
 * Format time for message content display
 * Rules:
 * - Day within the last week (i.e. "Tuesday, 11:32 AM")
 * - Full date and time when beyond the last week (i.e. "12/24/24, 11:58 AM")
 */
export function formatMessageTime(date: Date | string): string {
  const jsDate = date instanceof Date ? date : new Date(date)
  const dt = DateTime.fromJSDate(jsDate)
  const now = DateTime.now()

  // Check if within last 7 days
  const daysDiff = now.diff(dt, 'days').days
  if (daysDiff < 7) {
    return dt.toFormat('EEEE, h:mm a') // "Tuesday, 11:32 AM"
  }

  // Beyond last week
  return dt.toFormat('M/d/yy, h:mm a') // "12/24/24, 11:58 AM"
}
